const data = [
  { id: 1, name: "Habilitação" },
  { id: 2, name: "Divergência" }
];

export default [...data];
